import { Navigate, useParams } from "react-router-dom";
import useCapabilities, { useCanViewBeneficiariesBool } from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import usePageTitle from "@/hooks/usePageTitle";
import { useShowCommissionPersonGrpTab, useShowRetirementPersonGrpTab } from "../_utils";
import GrpPersonBenefitsView from "./_components/GrpPersonBenefitsView";
import CommissionPersonGrpBenefits from "./_CommissionPersonGrpBenefits";
import { GRP_PERSON_PROFILE_FLAG } from "./constants";
import RetirementPersonGrpBenefits from "./_RetirementPersonGrpBenefits";

export default function PersonGrpBenefitsPage() {
  const { pgaId } = useParams();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded: capabilitiesLoaded } = useCapabilities();
  const canViewBeneficiaries = useCanViewBeneficiariesBool();
  const showCommissionGrp = useShowCommissionPersonGrpTab();
  const showRetirementGrp = useShowRetirementPersonGrpTab();
  const flagOn = !!flags[GRP_PERSON_PROFILE_FLAG];

  usePageTitle("/people/:pgaId/benefits/grp", "Golf Retirement Plus");

  if (!pgaId) return null;

  if (!flagsLoaded || !capabilitiesLoaded) {
    return <GrpPersonBenefitsView status="loading" />;
  }

  if (!flagOn && !showCommissionGrp) {
    if (canViewBeneficiaries) {
      return <Navigate to={`/people/${pgaId}/benefits/beneficiaries`} replace />;
    }
    return <Navigate to={`/people/${pgaId}`} replace />;
  }

  if (flagOn && !showRetirementGrp && !showCommissionGrp) {
    return <GrpPersonBenefitsView status="forbidden" />;
  }

  const bothPanels = showRetirementGrp && showCommissionGrp;

  return (
    <>
      {showRetirementGrp ? <RetirementPersonGrpBenefits /> : null}
      {showCommissionGrp ? <CommissionPersonGrpBenefits stacked={bothPanels} /> : null}
    </>
  );
}
